<template>
    <div v-if="!mobileNav().isOpen" class="fixed bottom-0 left-0 z-50 h-16 w-full bg-primary shadow-md lg:hidden">
        <Button @click="showCartModal">
            <span class="relative mr-4 size-6">
                <Icon :icon="IconShoppingCart" class="size-6 text-2xl text-white" />
                <span v-if="cart().getCartQuantity > 0" class="absolute -right-2 -top-2 size-4 rounded-full bg-white text-xxs font-bold uppercase leading-4 text-primary-200">{{ cart().getCartQuantity }}</span>
            </span>
            <span class="text-xl font-bold uppercase text-white">
                {{ $t('cart.shoppingCart') }}&nbsp;({{ cart().hasCartProducts ? currencyFormat(cart().getCartTotalPrice) : currencyFormat(0) }})
            </span>
        </Button>
    </div>
</template>

<script setup lang="ts">
    import { useModal } from 'vue-final-modal'
    import IconShoppingCart from '@/assets/icons/shopping-cart.svg'
    import Button from '~/components/Button.vue'
    import Icon from '~/components/Icon.vue'
    import ModalCart from '~/components/Modal/ModalCart.vue'
    import { blockScroll, unBlockScroll } from '~/composables/blockScroll'
    import { cart } from '~/store/cart'
    import { mobileNav } from '~/store/mobileNav'
    function showCartModal (src: string) {
        const cartModalInstance = useModal({
            component: ModalCart,
            attrs: {
                src,
                onBeforeOpen () {
                    blockScroll(window.scrollY)
                },
                onBeforeClose () {
                    unBlockScroll()
                },
                onClose () {
                    cartModalInstance.close()
                }
            }
        })
        cartModalInstance.open()
    }
</script>
